import { render, staticRenderFns } from "./buttons-container.vue?vue&type=template&id=55613112&scoped=true&"
import script from "./buttons-container.vue?vue&type=script&lang=js&"
export * from "./buttons-container.vue?vue&type=script&lang=js&"
import style0 from "./buttons-container.vue?vue&type=style&index=0&id=55613112&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55613112",
  null
  
)

export default component.exports